import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsWorkOrderSource, PmsWorkOrderSource } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsWorkOrderSource>
    useData={usePmsWorkOrderSource}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
